// extracted by mini-css-extract-plugin
module.exports = {"container":"_268cab","alternative":"_beb04d"};